module.exports = __webpack_public_path__ + "static/media/chidinma-onuora.74205db2.jpg";